const AVAILABLE_HISTORY_ITEMS = {
  changelog: 'changelog',
  comment: 'comment',
  task: 'task',
  email: 'email',
  sms: 'sms',
  userTask: 'userTask',
};

export { AVAILABLE_HISTORY_ITEMS };
